/* ========================================================================
 * FD:          constructor
 * Child:       --
 * Version:     1.0
 * ========================================================================
 * must be first to load
 * pattern: module
 * ======================================================================== 
 * 12/01/2015: creation
*/


/* ========================================================================
 *  FD
 * ========================================================================
*/
var FD = (function (w) {
    return {};
}(window));


/* ========================================================================
 *  initialize the page
 * ========================================================================
*/
FD.PAGE = (function ($, me) {
    'use strict';

    var child = me.PAGE || {};


    //  after control event 
    child.getAfterControlEvent = function (data) { };


    //  after site view change event
    child.getAfterSiteViewChangeEvent = function (val) { };


    //  after pin state change event
    child.getAfterPinStateChangeEvent = function () { };


    //  get view props
    child.getViewProps = function () {  };


    //  init
    child.init = function () { };

    return child;
}(jQuery, FD));
